import { useEffect } from 'react';

import { useWaterTariffStore } from './use-water-tariff-store';

export const useFetchWaterTariffs = (tariffs) => {
  const { tariff, setTariff } = useWaterTariffStore();

  useEffect(() => {
    if (tariffs) {
      const { consumption, disposal } = tariffs ?? {};
      setTariff({ consumption_tariff: consumption, disposal_tariff: disposal });
      return () => {
        setTariff(null);
      };
    }
  }, [tariffs, setTariff]);

  return { tariff, setTariff };
};

export default useFetchWaterTariffs;
